// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"_2xREHWYY","header":"_2QZXCHTv","description":"igZi7F5y","createWidget":"_198jfpwC"};